module.exports = __webpack_public_path__ + "media/images/bg-itau-c3bac7b2bb87c525bfd50bc153585cdd.png";